import React from "react";

const SidebarMenu = ({
  items = [],
  title = "Navegação",
  activeColor = "#28a745",
}) => {
  const currentPath =
    typeof window !== "undefined" ? window.location.pathname : "";

  return (
    <nav className="modern-sidebar" aria-label={title}>
      {title && (
        <div className="menu-header">
          <small className="text-uppercase fw-bold text-muted letter-spacing-1">
            {title}
          </small>
        </div>
      )}

      <ul className="list-unstyled m-0 p-0">
        {items.map((item) => {
          const isActive = currentPath === item.href;

          return (
            <li key={item.href}>
              <a
                href={item.href}
                className={`menu-link ${isActive ? "active" : ""}`}
                aria-current={isActive ? "page" : undefined}
                style={{
                  "--menu-primary": activeColor,
                  "--menu-primary-soft": `${activeColor}15`,
                }}
              >
                <div className="content-wrapper">
                  <div className="status-indicator">
                    {isActive && <span className="pulse-dot" />}
                  </div>
                  <span className="menu-label">{item.label}</span>
                </div>

                <i className="bi bi-chevron-right arrow-icon" />
              </a>
            </li>
          );
        })}
      </ul>

      <style>{`
        .modern-sidebar {
          background: #ffffff;
          border-radius: 16px;
          padding: 20px 12px;
          margin-right: -20px;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .menu-header {
          padding: 0 16px 12px 16px;
        }

        .letter-spacing-1 {
          letter-spacing: 1px;
          font-size: 0.7rem;
        }

        .menu-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 16px;
          margin-bottom: 6px;
          border-radius: 12px;
          text-decoration: none;
          color: var(--menu-text, #4a4a4a);
          font-weight: 500;
          transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
          position: relative;
          border: 1px solid transparent;
        }

        .content-wrapper {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        /* Hover */
        .menu-link:hover {
          background-color: #f8f9fa;
          color: var(--menu-primary);
          transform: translateX(4px);
        }

        /* Active */
        .menu-link.active {
          background-color: var(--menu-primary-soft);
          color: var(--menu-primary);
          font-weight: 600;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .menu-link.active::before {
          content: '';
          position: absolute;
          left: 0;
          top: 20%;
          height: 60%;
          width: 4px;
          background: var(--menu-primary);
          border-radius: 0 4px 4px 0;
        }

        /* Dot */
        .status-indicator {
          width: 8px;
          display: flex;
          justify-content: center;
        }

        .pulse-dot {
          width: 6px;
          height: 6px;
          background-color: var(--menu-primary);
          border-radius: 50%;
          box-shadow: 0 0 0 rgba(40, 167, 69, 0.4);
          animation: pulse-animation 2s infinite;
        }

        .arrow-icon {
          font-size: 0.75rem;
          opacity: 0.3;
          transition: all 0.3s ease;
        }

        .menu-link:hover .arrow-icon {
          opacity: 1;
          transform: translateX(2px);
        }

        .menu-link:focus-visible {
          outline: none;
          box-shadow: 0 0 0 3px rgba(40, 167, 69, 0.2);
        }

        @keyframes pulse-animation {
          0% { box-shadow: 0 0 0 0px rgba(40, 167, 69, 0.7); }
          70% { box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
          100% { box-shadow: 0 0 0 0px rgba(40, 167, 69, 0); }
        }

        @media (max-width: 768px) {
          .modern-sidebar {
            margin-bottom: 20px;
          }
        }
      `}</style>
    </nav>
  );
};

export default SidebarMenu;